// extracted by mini-css-extract-plugin
module.exports = {"title":"EmptyLandingPage_title__TSKNT","body":"EmptyLandingPage_body__hk1IZ"};